<template>
  <div :id="`${videoPlayerId}-bgVideo-container`" class="background" style="z-index: 0">
    <div class="background" :id="`${videoPlayerId}-videoPlayerBackground`"></div>
    <!-- transition group is being used in video play within the same route
         :transition="`card`"
    -->
    <!--<transition-group class="transition-group" :name="updateTransitionGroup" mode="in-out">-->
      <video class="background transitionItem"
             @timeupdate="videoTimeUpdateEventHandler"
             @playing="videoStartedEventHandler"
             @ended="videoEndedEventHandler"
             v-bind:class="{'blur-filter': isBlur}"
             :key="`${videoPlayerId}-master`" v-show="masterInUse"
             :id="`${videoPlayerId}-master`" type="video/mp4" 
             muted 
             playsinline webkit-playsinline
             style="cursor: default; z-index: 200;">
        Your browser does not support the video tag.
      </video>
      <video class="background transitionItem"
             @timeupdate="videoTimeUpdateEventHandler"
             @playing="videoStartedEventHandler"
             @ended="videoEndedEventHandler"
             v-bind:class="{'blur-filter': isBlur}"
             :key="`${videoPlayerId}-slave`" v-show="!masterInUse"
             :id="`${videoPlayerId}-slave`" type="video/mp4" 
             muted 
             playsinline webkit-playsinline
             style="cursor: default; z-index: 150;">
        Your browser does not support the video tag.
      </video>
    <!--</transition-group>-->
  </div>
</template>

<script>
  import { EventBus } from '../assets/js/event-bus';

  export default {
    name: 'background-video-player',
    components: {},
    /**
     *
     If we need to support push and loop video, then push must be [0] and loop will need to be [1] position at
     videoSources

     useEndFrameWithoutPlay: if this has a value >= 0, it means uses the endframe of the corresponding videoSource
     if ShowAfterPlay is not empty, then useEndFrameWithoutPlay will show the div defines in
     showAfterPlay instead of showing EndFrame

     videos: [
     {
       video: './static/videos/intro_1.mp4',
       // Better transition if it takes the first frame of the second video as end frame.
       firstFrame: './static/images/optimizing-gen-fleets/challenge/challenge-start.jpg',
       lastFrame: './static/images/optimizing-gen-fleets/challenge/chal-end.jpg',
     },
     {
       video: './static/videos/loopingvideo_1.mp4',
       firstFrame: './static/images/optimizing-gen-fleets/challenge/chal-end.jpg',
       // lastFrame: './static/images/optimizing-gen-fleets/challenge/chal-end.jpg',
     },
     ],

     loop - whether to loop the last video
     hoverableId = this is linked to a hoverable svg component if there exists an overlay on top of this video component
     so the hover effect can be enabled and disabled at the right time.
     */

    props: {
      videos: Array,  // And array of video objects { }
      videoPlayerId: { type: String, required: true },
      videoPlayList: Array,  // An array of index of video to play
      loop: { type: Boolean, default: false },
      hidePlayerWhenDone: { type: Boolean, default: false },
      showAfterPlay: String,
      hoverableId: String,
      useEndFrameWithoutPlay: Number,
      blur: { type: Boolean, default: false },     // blur the video ie Modal dialog with Blur video background
      transition: { type: String },                // use when playing video within the same route between (master/slave or new playlist)
    },

    computed: {
      enableAudio() {
        return true;
        // return this.$store.state.enableAudio;
      },
      updateTransitionGroup() {
        const updateTransition = typeof this.transition === 'undefined' ? this.transitionGroup : this.transition;
        // console.log('transition group is ' + updateTransition);
        return updateTransition;
      },
    },
    created() {
      // console.log(this.videoPlayerId + ':' + this._uid  + ' Create background video player.');
      // define private var here
      this.debug = 0;
      this.finishPlayingBeforeLeaveRoute = false;
    },
    activated() {
      // console.log('background-video-player activated- keep alive!!')
      this.activated();
    },
    mounted() {
      /**
       * Code here is to monitor exception occur during background video player.
       * There is no functionality here.
       **/
      const updateHandler = function (videoPlayerId) {
        // console.log(videoPlayerId + ' Exception Event received');
        if (this.videoPlayerId === videoPlayerId) {
          // debugger;
          // console.log('Should handle exception here for ' + this.videoPlayerId);
        }
      }.bind(this);

      EventBus.$on('BackgroundPlayVideoException', updateHandler);
      EventBus.$on('transition-afterLeave-route', this.cleanUpRoute);
      EventBus.$on('blur-video', this.blurVideo);

      // debugger;
      // console.log('*******************  VUE - MOUNTED **********************');
      /*
       This component plays a full screen background videos.
       It could also enable hoverable polygon (when mouse over, we can see a glass pane which usually
       navigate to another view).  Hoverable component is enabled under two conditions
       - When all videos are done
       - Or when all video is done except for the last looping video, then hoverable will be enabled
       before the looping video start.
       */
      this.videoSource = this.videos;

      this.media = document.getElementById(this.videoPlayerId + '-master');
      this.mediaSlave = document.getElementById(this.videoPlayerId + '-slave');
      this.mediaBackground = document.getElementById(this.videoPlayerId + '-videoPlayerBackground');
      this.svg = document.getElementById(this.hoverableId);
      this.instanceId = this._uid;  // for debug purpose

      this.playList = this.initPlayList(this.videoPlayList);  // video playList of video ex [ 0, 2, 4]
      this.setLastFrameAsBackgroundImageEnable = false;

      this.isBlur = this.blur;

      // debugger;
      // Observe src changes here for debugging purpose.
      if (this.debug) {
        var that = this;
        var target = this.media;
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            // console.log("########### Video CHANGE:" + mutation.type + ':' + mutation.attributeName);
            if (mutation.attributeName === 'src') {
              var src = mutation.target.getAttribute('src');
              that.debugLog('src is ' + src);
              // console.trace('src is CHANGED');
              if (!src) {
                // console.trace('src is empty');
              }
            }
          });
        });
        // configuration of the observer:
        var config = {attributes: true, childList: true, characterData: true};

        // pass in the target node, as well as the observer options
        observer.observe(target, config);
      }
      // this.readyToGo();
      // this.activated();
    },
    // beforeDestroy() {
    //   // Destroying video element will affect the transition for a background video player
    //   // as the video will be removed from dom and a blank page will be in the transition
    //   // instead of the video background.
    //   //      this.videoPlayer.media().outerHTML = '';
    //   //      delete this.videoPlayer.media();
    //   // this.debugLog('*********** Clean up - stop *****************');
    //   // this.media.removeEventListener('play', this.videoStartedEventHandler);
    //   // this.media.removeEventListener('ended', this.videoEndedEventHandler);
    //   //
    //   // this.mediaSlave.removeEventListener('play', this.videoStartedEventHandler);
    //   // this.mediaSlave.removeEventListener('ended', this.videoEndedEventHandler);
    //   // console.log('BEFORE DESTROY ' + this.videoPlayerId + ':' + this._uid  +  ' Background-VideoPlayer REMOVED');
    // },
    // deactivated() {
    //   // this.cleanUp();
    // },
    destroyed() {
      this.cleanUp();
    },
    data() {
      return {
        videoSource: undefined,
        indexOfPlayList: 0, // define i
        media: undefined,
        mediaSlave: undefined,
        mediaBackground: undefined,
        svg: undefined,
        instanceId: undefined,
        loopEnabled: undefined,
        playList: undefined,  // video playList of video ex [ 0, 2, 4]
        videoNum: undefined,
        setLastFrameAsBackgroundImageEnable: undefined,
        enableHoverableWhenVideoFinish: true,
        debug: undefined,
        isBlur: false,
        masterInUse: false,  // is master video player in use, use means it is the visible one
        isLoading: false,    // help to block user from playing video too quickly
        currentVideoPlayer: undefined,
        transitionGroup: 'no-transition',
        reportingPlayTime: undefined, // trigger an event base on the play percentage define here
        currPlayTime: undefined,         // keep track of the next reporting play time
      };
    },
    methods: {
      activated() {
        // console.log('Activated ' + this.videoPlayerId);
        this.indexOfPlayList = 0; // define i
        this.videoNum = 0;
        this.loopEnabled = false;
        // always use master first, thus set to false to make master available
        this.masterInUse = false;
        this.currentVideoPlayer = undefined;

        this.reportingPlayTime = [25, 50, 75], // adobe analytics - play and ended || 0% and 100% will always be reported
        this.currPlayTime = this.reportingPlayTime[0]
      },
      /**
       * vidoeList to play [0, 3, 5] of videoSources as example
       */
      playVideoList: function (videoList) {
        // debugger;
        // console.log('play playlist now');
        // this.transitionGroup = 'fade'; // use fade transition for switching between video list
        this.playList = this.initPlayList(videoList);
        this.play();
      },
      readyToGo: function () {
        // console.log('readyToGo ' + this.videoPlayerId);
        // debugger;
        // If route is coming from VRPlayer, then always use endframe without playing video
        if (this.useEndFrameWithoutPlay >= 0 || window.fromRoute.name === 'VRPlayer') {
          // debugger;
          // console.log('UseEndFrameOnly of video number: ' + this.useEndFrameWithoutPlay);
          // if showAfterPlay is defined, then the div id will be used instead of endframe
          if (this.showAfterPlay) {
            document.getElementById(this.showAfterPlay).style.display = 'block';
            this.showVideoPlayerAndHideBackground(false);
          } else {
            if (this.useEndFrameWithoutPlay >= 0) {
              this.setEndFrame(this.useEndFrameWithoutPlay);
            } else {
              this.setEndFrame(0); // mostly coming from VRPlayer, so use default push end frame.
            }
          }
        }
        /**
         * We can prop in :videoPlayList and change the playList
         * when we use BaseViewClass so we could play different playlist
         * i.e have one playList to play [0, 1] (push and loop by default,
         * but have another playList [1] when coming from child page, only
         * play loop and skip push.
         */
        else if (Array.isArray(this.videoPlayList)) {
          // console.log('readyToGo - videoPlayList ' + this.videoPlayerId);
          this.playVideoList(this.videoPlayList);
        } else {
          this.play();
        }
      },
      /**
       * Video Player methods
       *
       */
      play() {
        this.debugLog('  ******************  PLAY *****************');
        // if (this.isPlaying()) return; //To prevent user from clicking away while video is playing
        this.hoverableSVGEnable(this.enableHoverableWhenVideoFinish ? 0 : 1);  // 0 to disable
        this.playVideos();
      },
      cleanUpRoute(name) {
      // if (`${name}-videoPlayer` === this.videoPlayerId) {
      // debugger
        if (this.videoPlayerId.indexOf(name) === 0) {
          this.debugLog(`clean up ${this.videoPlayerId}`);
          this.cleanUp();
        }
      },
      blurVideo(blurEnable) {
        this.isBlur = blurEnable;
      },
      cleanUp() {
        /**
         * Must removeAttribute 'src' as setting src to '' will trigger an
         * http request to '' on IE with a return 404.  In IE, this 404 return
         * caused a blank page for the looping video during transition.  As the null
         * src will replace the video that is looping.
         * @type {string}
         */
        /**
         * Setting src = "" will cause Edge to fail loading the empty
         * src, thus it will not able to play video or load another video
         * with valid src.
         */
        this.$nextTick(() => {
          // clean up memory only in IE and Edge otherwise there will be a memory leak
          // Chrome handles the memory so we don't need to clean up.  If we do clean up
          // then the video will be remove before the page transition thus causes the
          // background image to show right before moving to the next page.
          //
          // Must removeAttribute 'src' as setting src to '' will trigger an
          // http request to '' on IE with a return 404.  In IE, this 404 return
          // caused a blank page for the looping video during transition.  As the null
          // src will replace the video that is looping.
          //
          // Cleaning it here cause it to blink.
          this.debugLog(window.browser.name);
          // Only try to clean up if not chrome, as chrome handles memory
          // de-allocation well.  Thus chrome or electron doesn't need video
          // clean up.
          if (window.browser.name !== 'chrome'
            // the code below is to unload page that has multiple video
            // otherwise it will flash the end of a video when we arrive
            // to the page where it had been load before.  i.e page has
            // push and loop video, where it plays the loop video, then
            // go to child page, and back to the original page.  The loop
            // video will flash before it load the push video.
            || this.videoSource.length > 1
          ) {
            // console.log(`${this.videoPlayerId} video remove src and load`);
            // clean up video src
            this.media.removeAttribute('src');
            this.media.load();
            this.mediaSlave.removeAttribute('src');
            this.mediaSlave.load();
          }
        });
      },
      setEndFrame(videoNum) {
        // debugger;
        this.setLastFrameAsBackgroundAndPoster(videoNum);
        this.showVideoPlayerAndHideBackground(false);
        this.hoverableSVGEnable(true);
      },
      readyToLeave(next) {
        if (typeof next === 'function') {
          // debugger;
          next();
        }
      },
      initPlayList(videoPlayList) {
        this.indexOfPlayList = 0;
        // debugger;
        let playList;
        // @todo play list initiazation.
        if (typeof videoPlayList !== 'undefined') {
          // debugger;
          playList = videoPlayList;
        } else {
          // all videos in video source become the play lisst
          // construct array [0, 1, 2, 3 ... N]
          // debugger;
          const N = this.videoSource.length;
          playList = Array.apply(null, {length: N}).map(Number.call, Number);
        }

        return playList;
      },
      getVideoSourceIndexFromPlayList(playListIndex) {
        // debugger;
        return this.playList[playListIndex];
      },
      isPlaying() {
        const video = this.media;
        const isMasterPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
        const videoSlave = this.mediaSlave;
        const isSlavePlaying = videoSlave.currentTime > 0 && !videoSlave.paused && !videoSlave.ended && videoSlave.readyState > 2
        // console.log(this.videoPlayerId + ' Video is playing ' + isPlaying);
        return isMasterPlaying || isSlavePlaying;
      },
      enableHoverableWhilePlaying(enable) {
        this.enableHoverableWhenVideoFinish = !enable;
      },
      hoverableSVGEnable(enable) {
        // debugger;
        this.debugLog(`hoverableSVG ${enable}`);
        if (this.svg !== undefined && this.svg !== null) {
          this.svg.style.display = enable ? '' : 'none';
        }
      },
      playVideos() {
        let firstVideo = 0;
        if (this.playList) {
          firstVideo = this.playList[0];
        }
        this.setBackgroundAndPlayVideo(firstVideo); // play the video, 0 is the first video
      },
      setFirstFrameAsBackgroundAndPoster(videoNum) {
        this.debugLog(' Setting firstFrame as background and poster');
        // debugger;
        // @todo modulize Preloader properly
        window.preloader.setBackGroundImage(this.mediaBackground, this.videoSource[videoNum].firstFrame);
        // mediaBackground.style.backgroundImage = 'url(' + videoSource[videoNum].firstFrame + ')';
        // NOTE: This cause Safari to not play video when we set poster during video play.
        // media.setAttribute('poster', videoSource[videoNum].firstFrame);
      },
      setLastFrameAsBackgroundAndPoster(videoNum) {
        this.debugLog(' Setting lastFrame as background and poster');
        window.preloader.setBackGroundImage(this.mediaBackground, this.videoSource[videoNum].lastFrame);
        // mediaBackground.style.backgroundImage = 'url(' + videoSource[videoNum].lastFrame + ')';
        // NOTE: This cause Safari to not play video when we set poster during video play.
        // see media.setAttribute('poster', videoSource[videoNum].lastFrame);
      },
      setBackgroundVideoSrc(videoNum) {
        if (typeof this.videoSource[videoNum] !== 'undefined' &&
          this.videoSource[videoNum].hasOwnProperty('firstFrame')) {
          // Not need to set first frame as video background
          // As the background video is buffered to play, so
          // when it gets to this point, the video is ready
          // thus, there is no need to download firstframe for poster
          // NONETHELESS, it will be automatically load if it is defined in config.json
          this.setFirstFrameAsBackgroundAndPoster(videoNum);
          this.showVideoPlayerAndHideBackground(false);
        }

        const mediaToPrepare = this.getMediaNotInUse();
        // Get the state of background
        const isBackgroundVisible = this.mediaBackground.style.zIndex === 0;
        mediaToPrepare.setAttribute('src', this.getSourceURL(this.videoSource[videoNum].video));
        this.setLoopForVideo(mediaToPrepare, videoNum);

        /**
         * The following logic is to prevent productexplorer page to switch the video
         * from background to foreground.  When running the app by itself, the background
         * div remains on top and only when video start do we bring the video to the front.
         * However, in the integrated productexplorer page, when the src is changed
         * the video is brought from the background to the front, since the src just changed
         * and load takes time, the screen becomes blank until the video starts playing.
         */
        if (isBackgroundVisible) {
          // re-enable the background if it was enabled before
          this.showVideoPlayerAndHideBackground(false);
        }
        mediaToPrepare.load();
        this.debugLog('Preset video ' + this.getVideoSourceIndexFromPlayList(this.indexOfPlayList));
      },

      setBackgroundAndPlayVideo(videoNum) {
        this.setBackgroundVideoSrc(videoNum);
        this.mediaPlay();
        this.debugLog('Play video ' + this.getVideoSourceIndexFromPlayList(this.indexOfPlayList));
      },

      setLoopForVideo(media, videoNum) {
        // debugger;
        const isLoop = typeof this.videoSource[videoNum].loop !== 'undefined';
        media.loop = isLoop;
        // console.log(`${media.id} Set loop to ${isLoop} for ${this.videoSource[videoNum].video}`);
      },

      getMediaNotInUse() {
        // return the media that is not currently in use
        return this.masterInUse ? this.mediaSlave : this.media;
      },

      getMediaInUse() {
        // return the media that is currently in use
        return this.masterInUse ? this.media : this.mediaSlave;
      },

      mediaPlay() {
        // https://developers.google.com/web/updates/2016/03/play-returns-promise
        // debugger;
        const mediaReadyToPlay = this.getMediaNotInUse();
        const playPromise = mediaReadyToPlay.play();
        // console.log(this.videoPlayerId + ' Media start play triggers');
        // debugger;
        const that = this;
        // console.log('Play Media Id:' + mediaReadyToPlay.id);
        if (playPromise !== undefined) {
          playPromise['myMedia'] = mediaReadyToPlay;
          playPromise.then(function () {
            // When video can play, then switch masterInUse to show and hide the video alternatively
            // Automatic play back started.
            // console.log(that.videoPlayerId + ' Media started playing - ' + that.masterInUse);
          }).catch((err) => {
            /**
             * KLUDGE ALERT!
             *
             * This part of the code is a problematic part where user rapidly switch views
             * i.e User comes into this link
             * http://localhost:8080/HEGT-Explorer/index.html#/hybrid-electric-gas-turbines/battery-energy-storage-system
             * then quickly click back twice  - Page A->Page B->Page A
             *
             * This will cause the exception to the video player where Page A will leave a blank page.
             * It has something to do with Vue internals as there are three instances of Page A and any code
             * we handle here will not be affecting the DOM.  Thus we are forcing this case to go HOME.
             */
            // console.error(' Exception occurs send event ' + window.toRoute.name);
            // debugger;
            // simply go to the last route again for now
            window.app.$router.go({ name: window.toRoute.name });
            // window.location.reload(true); // force a reload to the route name.
          });
        }
      },
      videoTimeUpdateEventHandler(e){
        let video = e.currentTarget  // could be master or slave
        if(e.currentTarget && e.currentTarget.duration){
          let percentage = Math.floor(( video.currentTime / video.duration ) * 100);
          // console.log(`${video.id} plays for ${percentage}, need to report next ${this.currPlayTime}`)
          for(let i=0; i < this.reportingPlayTime.length; i++){
            // console.log(`    ${this.reportingPlayTime[i]} reporting in array`)
            if( percentage >= this.reportingPlayTime[i] 
                && percentage <= this.reportingPlayTime[this.reportingPlayTime.length-1]
                && this.currPlayTime === this.reportingPlayTime[i]){
              this.$emit(`playtime-event`, video.src, video.duration, this.currPlayTime+'%');

              if( i+1 === this.reportingPlayTime.length){
                this.currPlayTime = this.reportingPlayTime[0]
              } else {
                this.currPlayTime = this.reportingPlayTime[i+1]
              }
              break
            }
          }          
        }
      },      
      videoStartedEventHandler(e) {
        let video = e.currentTarget

        if (this.loopEnabled) { 
          this.$emit('loop-repeat-event'); 
        }

        // adobe analytics to send play event
        this.$emit(`playtime-event`, video.src, video.duration, 'play');

        // kludge alert - there are instances where playing event is triggered twice
        // for one video play.  This ensure that master-slave are use alternatively
        if (this.currentVideoPlayer === e.currentTarget) return;
        this.currentVideoPlayer = e.currentTarget

        // console.log(` video started ${e.currentTarget.id} start.`);
        // console.log(` video started ${e.currentTarget.id} `);
        // console.trace('video started');
        // prevent using from playing new video while the last video is loaded but not played yet.
        // i.e user rapidly clicking to load different videoPlayList.
        this.isLoading = false;
        // debugger;
        // if media is playing in loop then let it play, this is true when the event is triggered by the media in used
        // if media is not in used,
        if (this.loopEnabled && this.getMediaInUse() === e.target) return;
        // this.getMediaInUse().pause();
        // switch to the player of the video by toggle masterInUse
        this.masterInUse = !this.masterInUse;
        this.loopEnabled = this.getMediaInUse().loop;


        this.$emit('video-start-event');
        if (this.loopEnabled) {
          this.hoverableSVGEnable(1);
          this.$emit('loop-start-event');
          this.transitionGroup = 'no-transition';
        }

        // debugger;
        // getVideoSourceIndexFromPlayList could be undefined when we are looping the last video as the
        // indexOfPlayList may exceed the length of videoSource.
        if (typeof this.getVideoSourceIndexFromPlayList(this.indexOfPlayList) !== 'undefined') {
          this.debugLog('video ' + this.getVideoSourceIndexFromPlayList(this.indexOfPlayList) + ' is playing now.');
          this.showVideoPlayerAndHideBackground(true);
          const i = this.getVideoSourceIndexFromPlayList(this.indexOfPlayList);
          this.enableHoverableOverlayWhenPlayingTheLastLoopingVideo(i);
          // Once the video started, then set background image and poster of endframe to ensure smooth transition
          if (typeof this.videoSource[i] !== 'undefined' &&
            this.videoSource[i].hasOwnProperty('lastFrame')) {
            // NOTE: The code below is to set the background image after a video has played.
            // So when video ends and switch to a High Definition background, the transition will
            // not cause a blink.  Nonetheless, setting the background as video poster
            // here causes Safari to not play video.  Thus we use a div as background instead of video poster
            // ALSO, we are setting the HD image as background instead of using the endframe of video
            // as background.  If we don't switch to HD background then there is no blink.
            this.setLastFrameAsBackgroundAndPoster(i);
          } else {
            this.media.removeAttribute('poster');
          }


          // preload next video src and load it in advance
          if (this.playList) {
            this.debugLog('preload next video while playing current one.');
            const nextVideoIndex = this.indexOfPlayList + 1;
            const videoSourceIndexForNextVideoInPlayList = this.getVideoSourceIndexFromPlayList(nextVideoIndex);

            // Play all video in sequence of playList
            if (videoSourceIndexForNextVideoInPlayList < this.videoSource.length) {
              const mediaToPrepare =  this.getMediaNotInUse();
              this.debugLog(`preload video to ${mediaToPrepare.id}.`);
              mediaToPrepare.setAttribute('src', this.getSourceURL(this.videoSource[videoSourceIndexForNextVideoInPlayList].video));
              this.setLoopForVideo(mediaToPrepare, videoSourceIndexForNextVideoInPlayList);
            }
          }
        }
      },

      videoEndedEventHandler(e) {
        // adobe analytics to send ended event
        let video = e.currentTarget
        this.$emit(`playtime-event`, video.src, video.duration, 'ended');

        // console.log(` video end ${e.currentTarget.id} has ended.`);
        // debugger;
        if (this.isPlaying()) {
          return;
        }
        this.debugLog('End video ' + this.indexOfPlayList);
        this.$emit('video-ended-event', this.indexOfPlayList);
        this.$emit('finish-video-event', this.indexOfPlayList);
        if (this.playList) {
          this.indexOfPlayList += 1;
        }

        const videoSourceIndexForNextVideoInPlayList = this.getVideoSourceIndexFromPlayList(this.indexOfPlayList);

        // debugger;
        // Play all video in sequence of playList
        if (videoSourceIndexForNextVideoInPlayList < this.videoSource.length) {
          // play the next video
          // this.setBackgroundAndPlayVideo(i);
          this.mediaPlay(); // play the preloaded video
        } else {
          this.handleAllVideosEndedWithoutLooping(this.playList[this.playList.length - 1]);
          // All videos are finished, thus enable svg overlay if any.
          // check to see if there is a svg for overlay, if so, enabled
          this.handleVideosAreAllDone();
        }
      },
      handleAllVideosEndedWithoutLooping: function (videoNum) {
        // This is when all videos are done and there is
        // no looping of the last video required.
        //
        // Display poster instead of last frame of video
        // The following two lines does reload the poster but it
        // also reload the video if not cached.
        // media.removeAttribute("src");
        // media.load();
        // NOTE: Switching to poster image after video is done causes a blink
        // Set src to '', it will show the poster
        // media.setAttribute('src', '');
        // if (this.setLastFrameAsBackgroundImageEnable) {
        //   if (typeof this.videoSource[videoNum] !== 'undefined' &&
        //     this.videoSource[videoNum].hasOwnProperty('lastFrame')) {
        //     this.showVideoPlayerAndHideBackground(false);
        //   }
        // }
        // safari browse on mac, safari browse on ios device (ipad/iphone)
        if (window.browser.name === 'safari' || window.browser.name === 'ios') {
          // Safari, when video ends, if user goes to another tab and comes back
          // Safari will load the first frame of the video.  Thus we need to pause
          // on the last frame.
          const lastFrameTime = this.currentVideoPlayer.duration;
          // frameRate is meant to be the duration for one frame
          let frameRate = 0.05;
          if (typeof this.videoSource[videoNum] !== 'undefined' &&
            this.videoSource[videoNum].hasOwnProperty('frameRate')) {
            frameRate = this.videoSource[videoNum].frameRate;
            // console.log(`Framerate is defined as ${frameRate}`);
          }

          // The last frame is the end minus the 30frames/second, so we take one second/30
          // to get the time it takes to produce one frame, but some video would yield a
          // blank video.  Thus we tested and use a const 0.05, which seems to work for
          // most cases.  ie. video transition and videos within pages.  Nonetheless,
          // frameRate is there in config.json to override this setting.
          this.currentVideoPlayer.currentTime = lastFrameTime - frameRate;
          this.currentVideoPlayer.pause();
          this.debugLog(`Safari pause lastframeTime - ${lastFrameTime} and set ${this.currentVideoPlayer.currentTime} in video.`);
          // console.log(`Safari pause lastframeTime - ${lastFrameTime} and set ${this.currentVideoPlayer.currentTime} in video.`);
        }
      },
      handleVideosAreAllDone() {
        this.$emit('all-video-ended-event');
        this.transitionGroup = 'no-transition';  // Ensure transition is NONE, thus it will not affect transition to other page
        this.hoverableSVGEnable(1);
        if (this.showAfterPlay) {
          document.getElementById(this.showAfterPlay).style.display = 'block';
        }
        if (this.hidePlayerWhenDone) {
          const containerId = "`${videoPlayerId}-bgVideo-container`";
          document.getElementById(containerId).style.display = 'none';
        }
      },
      /**
       * Check to see if video is in datastore
       * @param src
       */
      getSourceURL(src) {
        this.debugLog(' Is resource in cache? ' + src);
        if (src in window.dataStore) {
          this.debugLog(' Resource is in cache');
          return window.dataStore[src];
        }
        return src;
      },
      showVideoPlayerAndHideBackground(show) {
        if (show) {
          // Use zIndex to show/hide will remove the 'blink'
          this.media.style.zIndex = 0;
          this.mediaSlave.style.zIndex = 0;
          this.mediaBackground.style.zIndex = -1;
          this.debugLog(' Show video player, hide background');
        } else {
          this.mediaBackground.style.zIndex = 0;
          this.media.style.zIndex = -1;
          this.mediaSlave.style.zIndex = -1;
          this.debugLog(' Show background, hide video player');
        }
      },
      enableHoverableOverlayWhenPlayingTheLastLoopingVideo(currentIndex) {
        if (currentIndex === this.videoSource.length - 1 && this.loopEnabled === 1) {
          this.hoverableSVGEnable(1);
          this.$emit('loop-start-event');
        }
      },
      debugLog(msg) {
        if (this.debug === 1) {
          console.log(this.videoPlayerId + '|' + this.instanceId + ':' + msg);
        }
      },
    },
  };
</script>

<style lang="css" rel="stylesheet/css" scoped>
  /*@import "./resources/assets/sass/variables";*/

  .no-transition, .no-transition-leave-active {
    transition: none !important;
  }

  .no-transition-enter, .no-transition-leave-to {
    transition: none !important;
  }

  .fade, .fade-leave-active {
    transition: opacity .2s ease-in-out, transform .2s ease-in-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0.8;
  }

  /* For testing */
  .card {
    transition: all 0.5s;

  }
  .card-enter, .card-leave-to
    /* .card-leave-active for <2.1.8 */ {
    opacity: 0;
    transform: scale(0);
  }
  .card-enter-to {
    opacity: 1;
    transform: scale(1);
  }

  .card-leave-active {
    /*position: absolute;*/
  }

  .card-move {
    opacity: 1;
    transition: all 0.5s;
  }

  .blur-filter {
    -webkit-filter: blur(10px);
    -moz-filter: blur(10px);
    -o-filter: blur(10px);
    -ms-filter: blur(10px);
    filter: blur(10px);
  }
</style>


// WEBPACK FOOTER //
// Background-Video-Player.vue?a45e78e6